import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import { getJpdViewsServicePathPrefix } from '@atlassian/jira-polaris-lib-jpd-views-service/src/index.tsx';
import type { NavigationView } from '../types.tsx';

export const fetchView = (viewUUID: string): Promise<NavigationView> =>
	fetchJson<NavigationView>(`${getJpdViewsServicePathPrefix()}/v1/views/${viewUUID}`);

const fetchViewsFactory =
	<T,>(type: 'projects' | 'collections') =>
	(id: T): Promise<NavigationView[]> =>
		fetchJson<{
			views: NavigationView[];
		}>(`${getJpdViewsServicePathPrefix()}/v1/navigation/${type}/${id}/views`).then(
			(response) => response.views ?? [],
		);

/**
 * @param {number} id - Project's ID
 */
export const fetchProjectsViews = fetchViewsFactory<number>('projects');

/**
 * @param {string} id - Collection's UUID
 */
export const fetchCollectionsViews = fetchViewsFactory<string>('collections');
